import { inject, Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { frontendserverurl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
    private http = inject(HttpClient);
    private snack = inject(SnackService);

  uploadFile(file: File, hubId: string, fileType: string): Observable<number | boolean> {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('hubId', hubId);
    formData.append('fileType', fileType);

    return this.http.post(`${frontendserverurl}/knowledgehub/uploads`, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            if (event.total) {
              return Math.round((100 * event.loaded) / event.total);
            }
            return 0;
          case HttpEventType.Response:
            return true;
          default:
            return 0;
        }
      })
    );
  }
  async deleteFile(fileId: string): Promise<boolean> {
    return await new Promise((resolve) => {
      this.http.delete(`${frontendserverurl}/knowledgehub/${fileId}`).subscribe({
        next: (data) => {
          resolve(true);
        },
        error: (error) => {
          this.snack.error(error)
          resolve(false);
        }
      });
    });
  }

  async getHubFilesByHubId(hubId: string): Promise<any> {
    return await new Promise((resolve) => {
      this.http.get(`${frontendserverurl}/knowledgehub/${hubId}`).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          this.snack.error(error)
          resolve(false);
        }
      });
    });
  }
}
